import { Grid, Typography } from "@mui/material";
import Button from "../forms/button";
import Delimiter from "../forms/delimiter/Delimiter";
import React from "react";
import { DealPageActionButtonInfo } from "../../deals/dealsPageLayout/DealsPageHeader/DealsPageHeader";
import { uid } from "../../../helpers/utilsTS";

export type DKGridTitleBarProps = {
  title: string;
  actionButtons?: DealPageActionButtonInfo[];
};

export const DKGridTitleBar = (props: DKGridTitleBarProps) => {
  const { title, actionButtons } = props;

  return (
    <>
      <Grid container={true}>
        <Grid
          item={true}
          xs={6}
          sx={{ display: "flex", justifyContent: "flex-start" }}
        >
          <Typography variant={"h2"} noWrap>
            {title}
          </Typography>
        </Grid>
        <Grid
          item={true}
          xs={6}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          {actionButtons?.map((actionButton) => {
            return (
              <Button
                key={uid.rnd()}
                data-testid={actionButton.dataTestId}
                disabled={actionButton.disabled}
                type="secondary"
                size="medium"
                onClick={actionButton.onClick}
              >
                {actionButton.label}
              </Button>
            );
          })}
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Delimiter type="internal" shift="20" />
      </Grid>
    </>
  );
};
